;(function($) {

    'use strict';

    var rnn = window.rnn;

    function init() {

        // Bind click events for the packages Flatpage.
        $('.package-options .package').on('click', function() {
            rnn.modules.subscriptions.subscriptionPackagesContinue();
        });
        // The package Page has already had its events setup in the desktop js.
        // This is because we load both desktop and mobile js files.
    }

    rnn.modules.register('subscriptionsMobile', {
        init: init
    });

})(jQuery);
